export const SIGN_IN = 'providers/root/SignInProvider/SIGN_IN';
